import React, { Component } from "react"
import { Link } from "react-router"
import { Icon } from '@driftt/tide-core-legacy'
import UserMapping from "components/SFDC/containers/UserMapping"
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'

import './style.styl'

const SalesforceUserMapping = () => (
  <div className="common-integration-page-layout">    
    <IntegrationBreadcrumb 
      backLinkText="Salesforce integration"
      backLinkUrl="/settings/setup/salesforce"
    />
    <header>
      <h2 className="integration-header">Mapped Salesforce users</h2>
      <p>Map your Drift teammates to your Salesforce teammates or invite them to join the family!</p>
    </header>
    <div className="salesforce-mapping-description">
      <h3 className="integration-header">Use these mappings to:</h3>
      <div>
        <div className="salesforce-mapping-reason">
          <Icon width={20} name="user"/>
            <p>
              Route conversations to an identified contact's Salesforce account, contact, or lead owner. Just add a 
              <Link to="/settings/rules"> conversation routing rule.</Link>
            </p>
        </div>
        <div className="salesforce-mapping-reason">
          <Icon width={20} name="team-2"/>
            <p>
              Set the lead owner for new Drift leads that are created in Salesforce. You can set that up in your
              <Link to="/settings/salesforce/config"> synced Salesforce data.</Link>
            </p>
        </div>
      </div>
    </div>
    <UserMapping onChange={() => { }} />
  </div>
)

export default SalesforceUserMapping



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceUserMapping/index.js